import React, { useState, useEffect } from "react";
import DashboardLayout from "../DashboardLayout";
import { fetchGamesList, fetchMiscData } from "../../services/axios/apiManager";
import GamesList from "./gamesList";
import { useAppContext } from "../../services/context";
import { handleErrors } from "../../services/dataManager";
const Games = ({ navigate }) => {
  const { state } = useAppContext();
  const { permissions } = state;
  const [games, setGames] = useState([]);
  const [genres, setGenres] = useState([]);
  const [tagsData, setTagsData] = useState([]);

  const [genresList, setGenresList] = useState([]);
  const [tagsList, setTagsList] = useState([]);

  const [languages, setLanguages] = useState([]);
  const [pagination, setPagination] = useState({});
  const [granted, setGranted] = useState([]);

  const extractPermissions = () => {
    const perms = permissions.filter((f) => f.module === "Games");
    if (perms) {
      setGranted(perms);
    }
  };

  // // // Fetch Games list
  const fetchGames = async () => {
    const res = await fetchGamesList();
    if (res?.data?.success && res?.data?.data) {
      setGames(res.data.data);
      if (res?.data?.pagination) {
        setPagination(res.data.pagination);
      }
    } else {
      await handleErrors(res, navigate);
    }
  };
  // // // Fetch genres, tags and languages
  const fetchOtherData = async () => {
    const res = await fetchMiscData();
    if (res?.data?.data) {
      const genreData = res?.data?.data?.genres?.map((m) => m.name);
      const genreListData = res?.data?.data?.genres?.map((m) => ({
        label: m.name,
        value: m.name,
      }));
      setGenres(genreData);
      setGenresList(genreListData);
      const tagsTemp = res?.data?.data?.tags?.map((m) => m.name);
      const tagsTempList = res?.data?.data?.tags?.map((m) => ({
        label: m.name,
        value: m.name,
      }));
      setTagsData(tagsTemp);
      setTagsList(tagsTempList);
      setLanguages(res.data.data.languages || []);
    }
  };

  useEffect(() => {
    extractPermissions();
    fetchGames();
    fetchOtherData();
  }, []);

  return (
    <DashboardLayout>
      <div>
        <div className="row">
          <div className="col-12 mb-3">
            <div className="page-title-box d-sm-flex align-items-center justify-content-between">
              <div className="page-title-right">
                <ol className="breadcrumb m-0">
                  <li className="breadcrumb-item">
                    <a>Management</a>
                  </li>
                  <li
                    className="breadcrumb-item active"
                    style={{ color: "#d1cdcdbf" }}
                    data-testid="gameHeading"
                  >
                    Gaming Platform
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
        <GamesList
          games={games}
          setGames={setGames}
          setPagination={setPagination}
          genres={genres}
          tagsData={tagsData}
          languages={languages}
          pagination={pagination}
          granted={granted}
          genresList={genresList}
          tagsList={tagsList}
        />
      </div>
    </DashboardLayout>
  );
};
export default Games;
